import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetReeferAgesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReeferAgesQuery = { __typename?: 'query_root', container_insights_ages: Array<{ __typename?: 'container_insights_ages', id: any, label: string, min?: any | null, max?: any | null, created_at: any, updated_at: any }> };

export const GetReeferAgesDocument = gql`
    query GetReeferAges {
  container_insights_ages {
    id
    label
    min
    max
    created_at
    updated_at
  }}
`;

export function useGetReeferAgesQuery(
  options?: Omit<Urql.UseQueryArgs<GetReeferAgesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetReeferAgesQuery, GetReeferAgesQueryVariables>({
    query: GetReeferAgesDocument,
    ...options,
  });
}
